module.exports = require("dd-trace/packages/dd-trace/src/opentracing/span_context");